module.exports = "/images/vendor/flag-icon-css/flags/1x1/uy.svg?adbc4992aa0cb87499df3323234076f3";